export default abstract class ControllerBase {
    withLoader = true;
    constructor(withLoader: boolean | null = null) {
        if(withLoader !== null) {
            this.withLoader = withLoader;
        }
    }
}